<template>
    <div id="charLib">
        <div class="main-panel">
            <div>
                <div class="main-panel__header">

                    <el-button type="primary" size="medium" @click="isShowBatchAddChar = true">批量增加</el-button>
                    <el-button type="danger" size="medium" @click="batchDeleteChar()">批量删除</el-button>
                    <el-input style="width: 240px" class="search-input search-input--right"
                              size="medium"
                              placeholder="" icon="el-icon-search" @keyup.enter.native="handleInputChange"
                              v-model.trim="sensitiveWord">
                        <el-button slot="append" size="medium" icon="el-icon-search"
                                   @click="handleInputChange"></el-button>
                    </el-input>
                </div>
                <div class="char-list">
                    <div @click="charClickHandler(wordItem)" :class="['word-item', selectedCharIdList.includes(wordItem.id) ? 'word-item--active' : '']" v-for="wordItem in wordList">
                        {{wordItem.sensitiveWord}}
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="添加敏感词" :visible.sync="isShowBatchAddChar" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form ref="batchAddWordForm" :model="batchAddWordForm" :rules="batchAddWordFormRules"
                         label-width="120px">
                    <el-form-item label="敏感词汇" prop="sensitiveWords">
                        <el-input placeholder="敏感词以,分割" type="textarea" :maxlength="1000" :rows="5" v-model.trim="batchAddWordForm.sensitiveWords" style="width: 400px;"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowBatchAddChar = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="batchAddChar()">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize.js';
    import baseMixin from '@/mixins/baseMixin.js';

    import {
        deleteBatchSensitiveWord,
        addSensitiveWordBatch,
        querySensitiveList
    } from '@/api/wordBlacklist';

    const validatesensitiveWords = (rule, value, callback) => {
        value = `${value}`.trim();
        if (value === '') {
            callback(new Error('字库汉字不能为空'));
        }  else {
            callback();
        }
    };

    export default {
        name: 'wordBlacklist',
        mixins: [windowResize, baseMixin],
        data() {
            return {
                groupList: [],
                currentGroup: null,

                wordList: [],
                selectedwordList: [],
                selectedCharIdList: [],

                isShowBatchAddChar: false,
                batchAddWordForm: {
                    sensitiveWords: ''
                },
                batchAddWordFormRules: {
                    sensitiveWords: [
                        { required: true, validator: validatesensitiveWords },
                    ]
                },
                sensitiveWord: '',
            }
        },
        created() {
            this.querySensitiveListFunc();
        },
        methods: {
            querySensitiveListFunc() {
                querySensitiveList({
                    sensitiveWord: this.sensitiveWord
                })
                    .then(data => {
                        this.wordList = data;
                    })
            },
            handleInputChange() {
                this.selectedwordList = [];
                this.selectedCharIdList = [];
                this.sensitiveWord = this.sensitiveWord.trim();
                this.querySensitiveListFunc();
            },
            batchDeleteChar() {
                if(this.selectedCharIdList.length === 0) {
                    this.$message.error('请选择汉字');
                } else {
                    this.$confirm("确认要删除吗？", "删除", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                        lockScroll: false
                    }).then(() => {
                        deleteBatchSensitiveWord({
                            sensitiveWordIds: this.selectedCharIdList.join(',')
                        })
                            .then(() => {
                                this.batchAddWordForm.sensitiveWord = '';
                                this.$message.success('删除成功');
                                this.selectedwordList = [];
                                this.selectedCharIdList = [];
                                this.querySensitiveListFunc();
                            })
                    });
                }
            },
            batchAddChar() {
                this.batchAddWordForm.sensitiveWords = this.batchAddWordForm.sensitiveWords.trim();
                this.$refs.batchAddWordForm.validate(isValid => {
                    if(isValid) {
                        addSensitiveWordBatch({
                            sensitiveWords: this.batchAddWordForm.sensitiveWords
                        })
                            .then(() => {
                                this.sensitiveWord = '';
                                this.$message.success(`添加成功`);
                                this.isShowBatchAddChar = false;
                                this.batchAddWordForm.sensitiveWords = '';
                                this.querySensitiveListFunc();
                            })
                    }
                })
            },
            charClickHandler(wordItem) {
                const index = this.selectedwordList.findIndex(item => item.id == wordItem.id);
                if(index !== -1) {
                    this.selectedwordList.splice(index, 1);
                    this.selectedCharIdList.splice(index, 1);
                } else {
                    this.selectedwordList.push(wordItem);
                    this.selectedCharIdList.push(wordItem.id);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    #charLib {
        height: 100%;
    }

    .group-container {
        height: 300px;
        overflow-y: auto;
        @include scrollBar;
        width: 260px;

    }

    .main-panel {
        padding: 12px;
    }

    .title {
        margin: 10px 0;
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;
    }

    .group-item--title {
        width: 100px;
        height: 26px;
        margin-left: 20px;
        margin-top: 10px;
        display: block;
        color: #7B7B7B;
    }

    .group-item {
        height: 30px;
        text-align: left;
        line-height: 30px;
        display: block;
        padding: 0 30px;
        cursor: pointer;
        border-radius: 2px;
        position: relative;

        .fa {
            float: right;
            margin: 7px 0 0 10px;
            display: none;
        }
        &:hover {
            background-color: #ECECEC;
            .fa {
                display: block;
            }
        }
        &.group-item--active {
            background-color: #409EFF;
            color: #fff;
            .fa-edit {
                color: #fff;
            }
        }
        .fa-trash {
            color: #f08080;
        }
        .fa-edit {
            color: #409EFF;
        }
    }
    .char-list {
        padding-top: 12px;
    }
    .word-item {
        float: left;
        box-sizing: border-box;
        height: 80px;
        border: 2px solid #ddd;
        margin: 0 10px 10px 0;
        text-align: center;
        padding: 14px;
        font-size: 36px;
        cursor: pointer;
        position: relative;
        .fa-edit {
            position: absolute;
            font-size: 16px;
            right: 5px;
            top: 5px;
            color: #409EFF;
            display: none;
        }
        &:hover {
            .fa-edit {
                display: block;
            }
        }
        &.word-item--active {
            border: 2px solid #409EFF;
        }
    }
    .main-panel__header {
        padding-bottom: 10px;
        border-bottom: 1px solid #e4e7ed;
    }
    .char-container {
        width: 70px;
        height: 70px;
        font-size: 52px;
        margin: 0 auto;
        text-align: center;
        line-height: 80px;
        margin-bottom: 5px;
    }
    .form-item-container {
        width: 500px;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 10px;
    }
    .dialog-value {
        display: inline-block;
        vertical-align: middle;
        width: 280px;
        text-align: left;
    }
    .uploader-container {
        width: 140px;
    }
    .dialog-label {
        display: inline-block;
        vertical-align: middle;
        width: 200px;
        text-align: right;
        margin-right: 10px;
    }
    .add-line {
        color: #409EFF;
        cursor: pointer;
    }
    .form-item-container--voice {
        & > * {
            vertical-align: top;
        }
        .fa-close {
            color: #f08080;
            margin-left: 10px;
        }
    }
</style>
<style lang="scss">
    .dialog-form .is-current.is-focusable > .el-tree-node__content {
        background-color: #20a0ff !important;
        color: #fff !important;
    }
    #charLib .form-item-container--line {
        .upload-file-item {
            width: 80px;
            height: 80px;
        }
        .upload-file-item img {
            margin: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/wordBlacklist/wordBlacklist.vue